<template>
  <div>
    <h1 class="title font-weight-bold mt-2 mb-4">Dados históricos</h1>
    <v-row align="center">
      <v-col cols="12" md="12" class="mt-2">
          <v-icon class="mr-2" size="16" color="white" :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${basinIconColor};`">{{basinIconName}}</v-icon>
          <span v-if="location" class="pt-1" style="font-size: 16px;">{{location.text}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="mt-2 primary darken-1">
          <v-row class="pa-4" align="center" >
            <v-col cols="12">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span style="color: lightgrey; font-size: small" v-if="years">Atualizado em {{ years[years.length-1] }} </span>
              <span style="color: lightgrey; font-size: small" v-else>Atualizado em ##/##/####</span>
            </v-col>
          </v-row>

          <v-card-title class="mb-0">
            <v-col class="px-0">
              <h1 class="subtitle-1 font-weight-bold">
                Dados históricos da evolução do uso e cobertura da terra
              </h1>
              <span class="subtitle-1">
                Gráfico empilhado baseado na área total da bacia.
              </span>
            </v-col>
            <v-col class="px-0">
              <chart-header
                :authorize="authorize"
                @fullscreenChart="fullscreenChart"
                @printChart="printChart"
                @exportChart="exportChart($event)"
                @exportCSV="exportCSV"
                @exportXLS="exportXLS"
              ></chart-header>
            </v-col>
          </v-card-title>

          <v-card-text>
            <h3 class="subtitle-1 white--text">Selecione o tipo do dado</h3>
            <v-tabs class="hidden-sm-and-down secondary--text text--lighten-1" v-model="tab" active-class="secondary lighten-1 primary--text text--darken-1" background-color="primary darken-1" slider-color="secondary lighten-1">
              <v-tab class="tab-item-title" v-for="(item, index) in items" :key="index" :id="item.id">{{item.title}}</v-tab>
            </v-tabs>
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="hidden-md-and-up tab-item-title transparent" outlined v-bind="attrs" v-on="on">
                  {{items[tab].title}}
                  <v-icon >mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in items" :key="index" @click="changeTabItem(index)">
                  {{item.title}}
                </v-list-item>
              </v-list>
            </v-menu>

            <v-tabs-items v-model="tab" class="primary darken-1" touchless>
              <v-tab-item class="px-0">
                <v-card flat color="primary darken-1">
                  <v-card-text class="px-0 text-center">
                    <percentage-chart
                      :text="text"
                      :firstYear="returnFirstYear(years)"
                      :lastYear="returnLastYear(years)"
                      :percentageSeries="percentageSeries"
                      @chartRenderComplete="chartRenderComplete($event)"
                    ></percentage-chart>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat color="primary darken-1">
                  <v-card-text class="px-0 text-center">
                    <hectare-chart
                      :text="text"
                      :firstYear="returnFirstYear(years)"
                      :lastYear="returnLastYear(years)"
                      :hectareSeries="hectareSeries"
                      @chartRenderComplete="chartRenderComplete($event)"
                    ></hectare-chart>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
Exporting(Highcharts)
import PercentageChart from "./PercentageChart";
import HectareChart from "./HectareChart";
import ChartHeader from "../common/ChartHeader";
import { HistoricalDataConservationHectareChartAuthorization, HistoricalDataConservationPercentageChartAuthorization } from "../../helpers/chart_export_authorization";
export default {
  components: {ChartHeader, HectareChart, PercentageChart},
  props:{
    location:{
      required: true,
    },
    forecasts:{
      require: true
    },
    basinIcon:{
      type: Object,
      default:() => ({name: 'icon-infohidro-bacia', color: '#69D7A3'})
    },
    percentageSeries:{
      required: true,
    },
    hectareSeries:{
      required: true,
    },
    text:{
      required: true,
    },
    years:{
      required: true,
    },
  },
  name: "HistoricalDataConservation",
  data:()=>({
    tab: 0,
    chartRendered: undefined,
    enableExportChart: false,
    exportChartAuthorized: undefined,
    items:[
      {
        title: 'Porcentagem (%)',
        id: 'tab-percentage'
      },
      {
        title: 'Hectare (ha)',
        id: 'tab-hectare'
      }
    ],
    authorize: [],
  }),
  created(){
    this.authorize = HistoricalDataConservationPercentageChartAuthorization;
  },
  watch:{
    watchLocationAndForecastsValues(){
      if(this.location && this.forecasts){
        this.loadCharts();
      }
    },
    tab(value){
      if(value === 1){
        this.enableExportChart = true;
        this.loadCharts();
      }else{
        this.enableExportChart = false;
      }

      this.$gtag.event('tabs_conservation-HistoricalDataLandUseAndLandCover', {
        'event_category': 'HistoricalDataLandUseAndLandCover',
        'event_label': 'tab_index',
        'value': value
      });
    }
  },
  computed:{
    basinIconName(){
      return this.basinIcon.name ? this.basinIcon.name : 'icon-infohidro-bacia';
    },
    basinIconColor(){
      return this.basinIcon.color ? this.basinIcon.color : '#69D7A3';
    },
  },
  methods:{
    returnFirstYear(years){
      if (years){
        return years[0]
      }
    },
    returnLastYear(years){
      if (years){
        return years[years.length-1]
      }
    },
    loadCharts(tab){
      setTimeout(()=>{
        if(tab === 0){
          //this.$refs.rainFlowChart.chartPreprocessing();
          this.authorize = HistoricalDataConservationPercentageChartAuthorization;
        }else if(tab === 1){
          //this.$refs.permanenceChart.chartPreprocessing();
          this.authorize = HistoricalDataConservationHectareChartAuthorization;
        }
      }, 50);
    },
    chartRenderComplete(chart){
      this.chartRendered = chart;
    },
    exportChart(typeFile){
      this.chartRendered.exportChart({type: typeFile});
    },
    exportCSV(){
      this.chartRendered.downloadCSV();
    },
    exportXLS(){
      this.chartRendered.downloadXLS()
    },
    fullscreenChart(){
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart(){
      this.chartRendered.print();
    },
    changeTabItem(tabIndex){
      this.tab = tabIndex;
    },
  },
}
</script>

<style scoped>
.tab-item-title{
  color: var(--v-secondary-lighten1) !important;
  border: 1px solid var(--v-secondary-lighten1);
  text-transform: none;
}
#tab-percentage{
  border-radius: 4px 0px 0px 4px;
}
#tab-hectare{
  border-radius: 0px 4px 4px 0px
}
</style>
